module.exports = __webpack_public_path__ + "VideoJS.00103e881a36640a08f8.eot";


//////////////////
// WEBPACK FOOTER
// /builds/applied-technologies/apt-lab/digitalbank-frontend-projects/digitalbank-web/node_modules/video.js/dist/font/VideoJS.eot
// module id = ../../../../video.js/dist/font/VideoJS.eot
// module chunks = styles